import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import Field from '../fields/Field';
import Info from '../fields/Info';
import Btn from '../buttons/Btn';
import Link from '../link/Link';
import { PasswordField } from '../fields/PasswordField';

const SignupSchema = Yup.object().shape({
  email: Yup.string()
    .trim('Ce champ ne peut pas inclure d\'espace au début et à la fin')
    .strict(true)
    .email('Merci de renseigner une adresse email valide.')
    .required('Ce champ est obligatoire.'),
  password: Yup.string()
    .required('Ce champ est obligatoire.')
    .min(6, 'Votre mot de passe doit comporter au minimum 6 caractères.')
    .max(128, 'Votre mot de passe ne doit pas excéder 128 caractères.'),
});

const StyledForm = styled(Form)`
  max-width: 386px;
`;

class ExamSignInForm extends Component {
  render() {
    const {
      examCenterType,
      onFormSubmit,
      onClickGoToRegForm,
      formForRecoveryPoints,
    } = this.props;

    return (
      <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={SignupSchema}
        onSubmit={onFormSubmit}
      >
        {({
          values, errors, touched, handleChange, handleBlur, isSubmitting,
        }) => (
          <StyledForm>
            <Field
              type="text"
              label="Email"
              name="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
              valid={touched.email && !errors.email}
              errorMessage={errors.email && touched.email ? errors.email : null}
            />
            <PasswordField
              optionalText="Mot de passe oublié ?"
              optionalLink="/eleve_exam_code/password/new"
              name="password"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.password}
              valid={touched.password && !errors.password}
              errorMessage={
                errors.password && touched.password ? errors.password : null
              }
            />
            <Info examCenterType={formForRecoveryPoints ? "Lyra" : examCenterType} />
            <Btn
              type="submit"
              text={formForRecoveryPoints ? 'Réserver mon stage' : "Je réserve ma session"}
              block
              isLoading={isSubmitting}
              disabled={isSubmitting}
            />
            <Link
              text="Je n’ai pas de compte"
              block
              onClick={onClickGoToRegForm}
            />
          </StyledForm>
        )}
      </Formik>
    );
  }
}

ExamSignInForm.propTypes = {
  examCenterType: PropTypes.string,
  onClickGoToRegForm: PropTypes.func,
  onFormSubmit: PropTypes.func,
  formForRecoveryPoints: PropTypes.bool.isRequired,
};

ExamSignInForm.defaultProps = {
  examCenterType: '',
  onClickGoToRegForm: () => {},
  onFormSubmit: () => {},
  formForRecoveryPoints: false,
};

export default ExamSignInForm;
